import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { toast } from 'react-toastify';
import ApiService from '../../services/apiService';
import Authorization from './authorization';
import MessageGrid from '../purchaseRequisition/messageGrid';
import '../../Assets/styles/addmenu.css';
import { FaAngleLeft } from 'react-icons/fa6';
import { FaSave } from 'react-icons/fa';
import { BarLoader, ClipLoader } from 'react-spinners';
import moment from 'moment';
import UpdateItemGrid from './updateItemList';
import { getUserName } from '../../../Redux/selecters';
import { useSelector } from 'react-redux';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';
import UpdateAttachment from '../Attachment/UpdateAttachment';
import { PO_DETAIL_QUOTE_GRID, PO_DETAIL_FIELD_CELL, PO_DETAIL_REMARKS_SPAN, PO_REMARKS_NOTE_STYLE } from './poItemGridColumns';

const createEmptyRow = () => ({
  id: Date.now() + Math.random(),
  file: null,
  fileName: '',
  remarks: '',
});
const UpdatePurchaseOrder = () => {
  const apiService = new ApiService();
  const [activeTab, setActiveTab] = useState(0);
  const [SupplierTab, setSupplierTab] = useState(false);
  const { currencyprecision } = useCurrency();
  const [currencyPrecision, setCurrencyPrecision] = useState(currencyprecision);
  const [POTab, setPOTab] = useState(true);
  const [CostTab, setCostTab] = useState(false);
  const [gridVisibility, setGridVisibility] = useState([true, false, false]);
  const [messageData, setMessageData] = useState([]);
  const [authorizationData, setAuthorizationData] = useState([]);
  const [ItemsData, setRequisitionData] = useState([]);
  const [suppliers, setSupplier] = useState([]);
  const [payments, setPayments] = useState([]);
  const [SelectedCurrency, setSelectedCurency] = useState([]);
  const [isVatExcluded, setIsVatExcluded] = useState(true);
  const [isDiscountPercentage, setIsDiscountPercentage] = useState(true);
  const [usersDetails, setUser] = useState([]);
  const [Supplier, setSupplierData] = useState([]);
  const [poNumber, setPONumber] = useState([]);
  const [SupplierID, setSupplierID] = useState([]);
  const [SupplierContact, setSupplierContact] = useState();
  const [Payment, setPayment] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const [cost1, setCost1] = useState([]);
  const [cost2, setCost2] = useState([]);
  const [cost3, setCost3] = useState([]);
  const [loader, setLoader] = useState(false);
  const [cost4, setCost4] = useState([]);
  const itemData = location.state;
  const [LazyLoading, setLazyLoading] = useState(true);
  const userName = useSelector(getUserName);
  const [currencyList, setCurrencyList] = useState([]);
  const [overallDiscount, setOverallDiscount] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [vatAmount, setVatAmount] = useState(0);
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [Location, setLocation] = useState([]);
  const [discountInputType, setDiscountInputType] = useState("");


  // Attachment
  const [attachmentModal, setAttachmentModal] = useState(false);
  const [attachments, setAttachments] = useState([createEmptyRow()]);
  const closeModal = () => setAttachmentModal(false);
  const handleOpen = () => setAttachmentModal(true);

  const formatDateToDatetimeLocal = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };
  const getCurrentLocalDatetime = () => {
    const localDate = new Date();
    const offset = localDate.getTimezoneOffset() * 60000;
    const localISOTime = new Date(localDate - offset).toISOString().slice(0, 16);
    return localISOTime;
  };
  useEffect(() => {
    const item = location.state;
    const getApprovalUser = async () => {
      try {
        setLazyLoading(true);
        const currencylist = JSON.parse(localStorage.getItem('currencylist')) || [];
        setCurrencyList(currencylist)
        const params = new URLSearchParams();
        params.append('DocNo', itemData?.pOrderNo);
        params.append('DocumentType', 'Purchase Order');
        const response = await apiService.getApiParamater('GET_DOC_STATUS_EDIT', `?${params.toString()}`);
        setUser(response.data.result);
        const PaymentResponse = await apiService.get('GET_EPAYMENT');
        setPayments([{ value: null, description: 'None' }, ...PaymentResponse?.data?.result]);

        const SupplierResponse = await apiService.get('GET_SUPPLIER');
        setSupplier(SupplierResponse?.data?.result);

        let param = `?Exp3=1`
        let res = await apiService.getApiParamater('GET_WAREHOUSE_MASTER', param)
        setLocation(res.data.result);
        let cost1 = await apiService.get('GET_COST_ONE');
        setCost1(cost1?.data?.result);
        let cost2 = await apiService.get('GET_COST_TWO');
        setCost2(cost2?.data?.result);
        let cost3 = await apiService.get('GET_COST_THREE');
        setCost3(cost3?.data?.result);
        let cost4 = await apiService.get('GET_COST_FOUR');
        setCost4(cost4?.data?.result);
        setIsVatExcluded(item.costCenter5 === 'excluded' ? true : false);
        const selectedpaymentTerm = PaymentResponse?.data?.result?.find((payment) => payment?.description === item?.terms);
        if (selectedpaymentTerm) {
          setPayment({ label: selectedpaymentTerm?.description, value: selectedpaymentTerm });
        }
        const selectedSuplier = SupplierResponse?.data?.result?.find((sup) => sup?.supplierName === item?.vendorName);
        if (selectedSuplier) {
          setSupplierData({ label: selectedSuplier?.supplierName, value: selectedSuplier });
          setSupplierID({ label: selectedSuplier?.supplier_ID, value: selectedSuplier });
          setSupplierContact(selectedSuplier?.phoneNo1);
        }
        setSelectedLocation({ label: item?.fax, value: item?.fax });
        let discount = parseFloat(item?.discountPerc)
        setOverallDiscount(discount || 0);
        setDiscountInputType(discount > 0 ? "percentage" : "")
        const formattedPODate = item?.docDate ? formatDateToDatetimeLocal(item?.docDate) : getCurrentLocalDatetime();
        const formattedDelivDate = item.deliveryDate ? formatDateToDatetimeLocal(item.deliveryDate) : getCurrentLocalDatetime();
        const selectedCurrency = currencylist?.find((sup) => sup?.code === item?.currencyCode);
        setFormData({
          PayOrderNo: item?.pOrderNo,
          Remarks: item.remarks,
          DocumentDate: formattedPODate,
          deliveryDate: formattedDelivDate,
          deliveryPoint: item.deliveryPoint,
          location: item.location,
          contactPerson: item.contactPerson,
          requisitionNo: item.requisitionNo,
          Department: item.department,
          Description: item.description,
          QuotationReq: item.quotationRef,
          BuyerName: item?.modifiedBy,
          ContactNo: item?.contractNo,
          RequisitionType: { label: item?.docId, value: item?.docId },
          costCenter1: { label: item?.costCenter1, value: item?.costCenter1 },
          costCenter2: { label: item?.costCenter2, value: item?.costCenter2 },
          costCenter3: { label: item?.costCenter3, value: item?.costCenter3 },
          costCenter4: { label: item?.costCenter4, value: item?.costCenter4 },
          exchangeRate: selectedCurrency?.conversionRate || currencyPrecision?.conversionRate,
        });
        setSelectedCurency({ label: selectedCurrency?.code || currencyPrecision?.code, value: selectedCurrency });
        setCurrencyPrecision(selectedCurrency)
        setLazyLoading(false);
        let attachparam = `?DocNo=${itemData.pOrderNo}&DocType=${'PurchaseOrder'}`;
        const AttachmentResponse = await apiService.getApiParamater('GET_ATTACHMENT', attachparam);
        const existingAttachments = AttachmentResponse?.data?.result || [];
        if (existingAttachments) {
          setAttachments(mapAttachmentsFromApi(existingAttachments));
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    setPONumber(item?.pOrderNo);
    if (location.state) {
      getApprovalUser();
    }
  }, [location.state]);
  const [formData, setFormData] = useState({
    PayOrderNo: '',
    Remarks: '',
    DocumentDate: '',
    SupplierContact: '',
    deliveryDate: '',
    deliveryPoint: '',
    location: '',
    contactPerson: '',
    requisitionNo: '',
    RequisitionType: '',
    ContactNo: '',
    currencyCode: '',
    QuotationReq: '',
    costCenter1: '',
    costCenter2: '',
    costCenter3: '',
    costCenter4: '',
    CostCentre5: '',
    exchangeRate: '',
    Description: '',
    BuyerName: '',
    vendorId: '',
    vendorName: '',
    OrderType: '',
    paymentTerm: [],
    SupplierDep: [],
  });

  const mapAttachmentsFromApi = (apiData) => {
    const validFiles = apiData.filter((a) => a.fileName && a.fileName.trim() !== '');

    return [
      ...validFiles.map((item) => ({
        id: Date.now() + Math.random(), // UI id
        dbId: item.rcno, // backend id
        file: null, // existing file (no File object)
        fileName: item.fileName,
        remarks: item.remarks || '',
        isNew: false,
        isDeleted: false,
      })),
      createEmptyRow(),
    ];
  };
  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
    const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
    setGridVisibility(newGridVisibility);
  };
  const handleMessage = (data) => {
    setMessageData(data);
    console.log(data, 'reqData');
  };
  const handleRequisitionData = (data) => {
    setRequisitionData(data);
    console.log(data, 'reqData');
  };
  const handleAuthorization = (data) => {
    setAuthorizationData(data);
    console.log(data, 'reqData');
  };
  const handlecurChange = (selectedOption) => {
    setSelectedCurency(selectedOption)
    setFormData({ ...formData, exchangeRate: selectedOption?.value?.conversionRate });
  };
  const orderType = [
    { value: 'Local Purchase', label: 'Local Purchase' },
    { value: 'Import Purchase', label: 'Import Purchase' },
    { value: 'Fixed Assist Purchase', label: 'Fixed Assist Purchase' },
    { value: 'Non Inventory Purchase', label: 'Non Inventory Purchase' },
    { value: 'Hire Purchase', label: 'Hire Purchase' },
    { value: 'Internal Pay Order', label: 'Internal Pay Order' },
    { value: 'Open Pay Order', label: 'Open Pay Order' },
  ];
  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handlePayChange = (selectedOption) => {
    setPayment(selectedOption);
  };
  const handleSupplierChange = (selectedOption) => {
    setSupplierData({ label: selectedOption?.label, value: selectedOption });
    setSupplierID({ label: selectedOption?.value?.supplier_ID, value: selectedOption });
    setSupplierContact(selectedOption?.value?.phoneNo1);
    setPayment({ label: selectedOption?.value?.paymentTerm, value: selectedOption });
  };
  const handleDepChange = (selectedOption) => {
    setFormData({ ...formData, SupplierDep: selectedOption });
  };
  const itemType = [
    { value: 'Inventory', label: 'Inventory' },
    { value: 'FixedAsset', label: 'Fixed Asset' },
    { value: 'Services', label: 'Services' },
  ];
  const UpdatePO = async () => {
    setLoader(true);
    if (ItemsData.length === 0) {
      toast.warning('Please add items');
      setLoader(false);
      return;
    } else if (!Supplier.label) {
      toast.warning('Please Select Supplier');
      setLoader(false);
      return;
    }
    for (const item of ItemsData) {
      if (!item.itemDescription) {
        toast.warning(`Please Select Item`);
        setLoader(false);
        return;
      } else if (!item.qty) {
        toast.warning(`Please enter ${item.itemDescription} quantity`);
        setLoader(false);
        return;
      } else if (!item.qty || parseFloat(item.qty) <= 0) {
        toast.warning(`${item.itemDescription} quantity must be greater than 0`);
        setLoader(false);
        return;
      } else if (!item.baseAmount || parseFloat(item.baseAmount) <= 0) {
        toast.warning(`${item.itemDescription} unit price must be greater than 0`);
        setLoader(false);
        return;
      }
    }
    const totalAmount = ItemsData.reduce((sum, row) => sum + (parseFloat(row?.amount) || 0), 0);
    try {
      const apiService = new ApiService();
      const prDetailsData = ItemsData.map((item, index) => ({
        pOrderNo: poNumber,
        deliveryDate: formData.deliveryDate,
        status: 0,
        isActive: true,
        vatPerc: item?.vat,
        vatDesc: item?.vatDec,
        vatAmount: Number(item.vatAmount).toFixed(SelectedCurrency?.value?.precision || 3),
        vatUnitPrice: Number(item.vatAmount / item.qty).toFixed(SelectedCurrency?.value?.precision || 3),
        vatBaseAmount: Number(item.vatAmount).toFixed(SelectedCurrency?.value?.precision || 3),
        requisitionNo: formData?.requisitionNo || '',
        srno: item?.srno,
        rsrno: item?.rsrno,
        itemCode: item.ItemNo || item.recordId,
        itemDescription: item.itemDescription,
        uom: item.uom,
        qty: parseFloat(item.qty),
        baseUOM: item?.uom,
        baseQty: parseFloat(item.baseQty),
        specification: item.specification,
        convValue: parseFloat(item?.baseQty),
        unitPrice: Number(item.baseAmount).toFixed(4),
        amount: Number(item?.amount).toFixed(SelectedCurrency?.value?.precision || 3),
        baseAmount: parseFloat(Number(item?.amount - item?.vatAmount).toFixed(SelectedCurrency?.value?.precision || 3)),
        discount: parseFloat(item.discount),
        discountPerc: overallDiscount,
        cancelledQty: 0,
        returnQty: 0,
      }));
      const currentDatetimeUTC = new Date().toISOString();
      const userData = {
        docId: itemData.requisitionNo === formData?.requisitionNo ? formData.RequisitionType?.label : formData.RequisitionType?.label || formData?.RequisitionType,
        currencyCode: SelectedCurrency?.label,
        exchangeRate: formData?.exchangeRate,
        modifiedOn: currentDatetimeUTC,
        modifiedBy: userName,
        // modifiedBy: formData.BuyerName,
        contractNo: formData?.ContactNo,
        poType: 'POrder',
        costCenter5: isVatExcluded === true ? 'excluded' : 'Included',
        baseAmount: Number(grandTotal).toFixed(SelectedCurrency?.value?.precision || 3),
        amount: Number(grandTotal).toFixed(SelectedCurrency?.value?.precision || 3),
        discountPerc: parseFloat(overallDiscount),
        discount: Number(discountAmount).toFixed(SelectedCurrency?.value?.precision || 3),
        contractedValue: Number(vatAmount || 0).toFixed(SelectedCurrency?.value?.precision || 3),
        quotationRef: formData?.QuotationReq,
        pOrderNo: itemData.pOrderNo,
        fax: selectedLocation?.label || "",
        terms: Payment.label,
        vendorId: SupplierID?.label.toString(),
        vendorName: Supplier?.label,
        docDate: formData?.DocumentDate,
        attention: SupplierContact,
        location: formData?.location,
        department: formData?.Department,
        deliveryPoint: formData?.deliveryPoint,
        contactPerson: formData?.contactPerson,
        status: ItemsData?.status,
        description: formData?.Description,
        remarks: formData?.Remarks,
        costCenter1: formData?.costCenter1?.label,
        costCenter2: formData?.costCenter2?.label,
        costCenter3: formData?.costCenter3?.label,
        costCenter4: formData?.costCenter4?.label,
        costCenter5: isVatExcluded === true ? 'excluded' : 'Included',
        poDetails: prDetailsData,
        requisitionNo: formData?.requisitionNo || '',
        deliveryDate: formData.deliveryDate,
        status: 0,
      };
      const response = await apiService.put('UPDATE_PO', userData);
      if (response?.data?.statusCode === 201 || 200) {
        const userData2 = {
          docType: 'POrder',
          docId: poNumber,
          status: 0,
          remarks: formData?.Remarks,
        };
        if (attachments) {
          let name = 'PurchaseOrder';
          let docNo = poNumber;
          handleUpload(name, docNo);
        }
        const response2 = await apiService.put('UPDATE_DOC_AUTHORIZATION_STATUS', userData2);
        const paramsGet = new URLSearchParams();
        paramsGet.append('docType', 'POrder');
        paramsGet.append('docId', poNumber);
        paramsGet.append('srno', 1);
        const response3 = await apiService.getApiParamater('GET_DOC_APPROVAL_USER', `?${paramsGet.toString()}`);
        // if (response3?.data?.result.length > 0) {
        //   const toEmails = response3?.data?.result?.map((user) => user.userEmail);
        //   const emailbody = {
        //     toEmails: toEmails,
        //     subject: 'Purchase Order',
        //     body: '',
        //     docNo: poNumber,
        //     srNo: 1,
        //     docType: 'POrder',
        //   };
        //   const emailres = await apiService.post('DOC_APPROVAL_EMAIL_POST', emailbody);
        // }
        toast.success(`${poNumber} Updated successfully`);
        setLoader(false);
        navigate('/Inventory/Purchase/K');
      }
    } catch (error) {
      setLoader(false);
      console.error('Error Creating PR:', error);
    }
  };
  const handleVatChange = () => {
    setIsVatExcluded(!isVatExcluded);
  };
  const handlePyorderChange = (selectedOption) => {
    setFormData({ ...formData, OrderType: selectedOption });
  };
  const handleDiscountChange = () => {
    setIsDiscountPercentage(!isDiscountPercentage);
  };
  const handleCost1 = async (selectedOption) => {
    let param = `?DropdownFor=GetUnitsByPropId&CascadValue=${selectedOption?.value?.exp1}`
    const response = await apiService.getApiParamater('GET_PR_CASCAD', param);
    let data = response?.data?.items || []
    setCost2([{ value: null, text: 'None' }, ...data]);
    setFormData({ ...formData, costCenter1: selectedOption, costCenter2: null });
  };
  const handleCost2 = (selectedOption) => {
    setFormData({ ...formData, costCenter2: selectedOption });
  };
  const handleCost3 = (selectedOption) => {
    setFormData({ ...formData, costCenter3: selectedOption });
  };
  const handleCost4 = (selectedOption) => {
    setFormData({ ...formData, costCenter4: selectedOption });
  };
  const handleBackClick = () => {
    window.history.back();
  };
  const handleItemTypeChange = (selectedOption) => {
    setFormData({ ...formData, RequisitionType: selectedOption });
  };
  // Attachment Functions
  const handleFileSelect = (file, id) => {
    setAttachments((prev) => {
      const updated = prev.map((row) =>
        row.id === id
          ? {
            ...row,
            file,
            fileName: file.name,
            isNew: true,
          }
          : row,
      );

      return [...updated, createEmptyRow()];
    });
  };
  const handleRemarkChange = (id, value) => {
    setAttachments((prev) => prev.map((row) => (row.id === id ? { ...row, remarks: value } : row)));
  };
  const handleDelete = (id) => {
    setAttachments((prev) => prev.map((row) => (row.id === id ? { ...row, isDeleted: true } : row)));
  };
  const handleUpload = async (name, docNo) => {
    const formData = new FormData();
    attachments.forEach(({ file }) => {
      if (file instanceof File) {
        formData.append('Images', file, file.name);
      }
    });

    const response = await apiService.postMultiPart('UPLOAD_FILE', formData);

    if (response?.data?.statusCode === 201 && response?.data?.isSuccessful) {
      const uploadedFileNames = response.data.result.split(',');
      let uploadedIndex = 0;

      const payload = {
        docFilesDtos: attachments
          .filter((a) => {
            if (a.isDeleted) return false;

            if (!a.isNew && a.fileName?.trim()) return true; // old files

            if (a.isNew && a.file instanceof File) return true; // new files

            return false;
          })
          .map((a, index) => {
            let fileName;

            if (a.isNew) {
              // Always use uploaded filename
              fileName = uploadedFileNames[uploadedIndex++]?.trim();
            } else {
              // Keep existing filename
              fileName = a.fileName?.trim();
            }

            return {
              rcno: a.dbId,
              srno: index + 1,
              docNo,
              docType: name,
              fileName,
              remarks: a.remarks || "",
            };
          }),
        docNo,
      };

      await apiService.put('UPDATE_ATTACHMENT', payload);
    }
  };
  const handleDropdownChange = async (name, value) => {

    if (name === "selectedLocation") {
      setSelectedLocation(value)
    } else {
      setFormData({ ...formData, [name]: value });
    }
  }
  return (
    <div className="px-4">
      <div className="d-flex justify-content-between pt-3">
        <h5 className="col mainInvHead">Purchase Order</h5>
        <div className="d-flex gap-3">
          {itemData?.eye === false ? (
            <>
              {loader === true ? (
                <button className="mainbtn " type="submit">
                  <ClipLoader color="#ffffff" size={25} />
                </button>
              ) : (
                <button className="mainbtn " type="submit" onClick={UpdatePO}>
                  <FaSave className="center mt-1 mx-2" />
                  <div>Update</div>
                </button>
              )}
            </>
          ) : (
            ''
          )}
          <button onClick={handleBackClick} className="mainbtnSecondary">
            <FaAngleLeft className="center mt-1 mx-2" />
            <div>Back</div>
          </button>
        </div>
      </div>
      {LazyLoading && (
        <div
          style={{
            position: 'absolute',
            inset: 0,
            background: 'rgba(255,255,255,0.6)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10,
          }}
        >
          <div className="spinner-border text-primary" role="status" />
        </div>
      )}
      <div className="cost-center-section">
        <div className="d-flex mt-3 cursor-pointer slide-header" onClick={() => setPOTab(!POTab)}>
          <div className="h6 pt-1">Purchase Order Details</div>
        </div>
        <div className={`slide-content ${POTab ? 'open' : 'closed'}`}>
          <div className={`border-box2 p-3 ${POTab ? 'slide-in' : 'slide-out'}`}>
            <>
              <div className="form-group justify-content-between row pb-3">
                <div className="col-4 d-flex justify-content-between">
                  <label htmlFor="InvoiceNO" className="form-label">
                    Purchase Order No
                  </label>
                  <input className="form-Input w-100" value={poNumber} name="poNumber" disabled />
                </div>
                <div className="col-4 d-flex justify-content-between">
                  <label htmlFor="DeliveryDate" className="form-label">
                    Delivery Date
                  </label>
                  {itemData?.eye === true ? (
                    <input
                      type="datetime"
                      disabled
                      className="form-Input w-100"
                      id="DeliveryDate"
                      value={moment(formData.deliveryDate).format('DD-MMM-YYYY')}
                      name="deliveryDate"
                    />
                  ) : (
                    <input
                      type="datetime-local"
                      className="form-Input w-100"
                      id="DeliveryDate"
                      value={formData.deliveryDate}
                      onChange={handleInputChange}
                      name="deliveryDate"
                    />
                  )}
                </div>
                <div className="col-4 d-flex justify-content-between">
                  <label htmlFor="Currency" className="form-label">
                    Currency{' '}
                  </label>
                  <Select
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: 5,
                      padding: 9,
                    })}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      option: (provided, state) => ({
                        ...provided,
                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                        color: state.isFocused ? '#000 ' : '#000',
                        ':hover': {
                          backgroundColor: '#F5F5F5',
                          color: '#000 ',
                        },
                      }),
                    }}
                    className="w-100 p-0"
                    menuPlacement="auto"
                    menuShouldScrollIntoView={false}
                    value={SelectedCurrency}
                    isDisabled={itemData?.eye === true ? true : false}
                    onChange={(e) => handlecurChange(e)}
                    options={currencyList?.map((po) => ({
                      value: po,
                      label: po.code,
                    }))}
                  />
                </div>
              </div>
              <div className="form-group row justify-content-between pb-3">
                <div className="col-4 d-flex justify-content-between">
                  <label htmlFor="DocumentDate" className="form-label">
                    Document Date
                  </label>
                  {itemData?.eye === true ? (
                    <input
                      type="datetime"
                      disabled
                      className="form-Input w-100"
                      id="DocumentDate"
                      value={moment(formData.DocumentDate).format('DD-MMM-YYYY')}
                      name="DocumentDate"
                    />
                  ) : (
                    <input
                      className="form-Input w-100"
                      id="DocumentDate"
                      value={formData.DocumentDate}
                      type="datetime-local"
                      disabled={itemData?.eye === true ? true : false}
                      name="DocumentDate"
                      onChange={handleInputChange}
                    />
                  )}
                </div>
                {/* <div className="col-4 d-flex justify-content-between">
                  <label htmlFor="deliveryPoint" className="form-label">
                    Delivery Point
                  </label>
                  <input
                    type="text"
                    className="form-Input w-100"
                    id="deliveryPoint"
                    disabled={itemData.eye === true ? true : false}
                    value={formData?.deliveryPoint}
                    onChange={handleInputChange}
                    name="deliveryPoint"
                  />
                </div> */}
                <div className="col-4 d-flex justify-content-between">
                  <label htmlFor="location" className="form-label">
                    Location
                  </label>
                  <input
                    type="text"
                    className="form-Input w-100"
                    id="location"
                    disabled={itemData.eye === true ? true : false}
                    value={formData.location}
                    onChange={handleInputChange}
                    name="location"
                  />
                </div>
                <div className="col-4 d-flex justify-content-between">
                  <label htmlFor="ExchangeRate" className="form-label">
                    Exchange Rate{' '}
                  </label>
                  <input
                    type="number"
                    className="form-Input w-100"
                    disabled
                    onWheel={(e) => e.target.blur()}
                    id="exchangeRate"
                    value={formData.exchangeRate}
                    onChange={handleInputChange}
                    name="exchangeRate"
                  />
                </div>
              </div>
              <div className="form-group row justify-content-between pb-3">
                <div className="col-4 d-flex justify-content-between">
                  <label htmlFor="requisitionNo" className="form-label">
                    Requisition No
                  </label>
                  <input
                    className="form-Input w-100"
                    name="requisitionNo"
                    id="requisitionNo"
                    disabled={itemData.eye === true ? true : false}
                    value={formData.requisitionNo}
                  />
                </div>
                <div className="col-4 d-flex justify-content-between">
                  <label htmlFor="contactPerson" className="form-label">
                    Contact Person
                  </label>
                  <input
                    type="text"
                    disabled={itemData.eye === true ? true : false}
                    className="form-Input w-100"
                    id="contactPerson"
                    value={formData.contactPerson}
                    onChange={handleInputChange}
                    name="contactPerson"
                  />
                </div>
                <div className="col-4 d-flex justify-content-between">
                  <label htmlFor="Description" className="form-label">
                    Supp Ref No
                  </label>
                  <input
                    type="text"
                    className="form-Input w-100"
                    id="Description"
                    disabled={itemData.eye === true ? true : false}
                    value={formData.Description}
                    onChange={handleInputChange}
                    name="Description"
                  />
                </div>
              </div>
              <div className="form-group row pb-3">
                <div className="col-4 d-flex justify-content-between">
                  <label htmlFor="RequisitionType" className="form-label">
                    Requisition Type
                  </label>
                  {itemData?.requisitionNo === '' ? (
                    <Select
                      isDisabled={itemData.eye === true ? true : false}
                      value={formData.RequisitionType}
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 5,
                        padding: 9,
                      })}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                          color: state.isFocused ? '#000 ' : '#000',
                          ':hover': {
                            backgroundColor: '#F5F5F5',
                            color: '#000 ',
                          },
                        }),
                      }}
                      className="w-100 p-0"
                      menuPlacement="auto"
                      menuShouldScrollIntoView={false}
                      options={itemType}
                      onChange={(selectedOption) => handleItemTypeChange(selectedOption)}
                    />
                  ) : (
                    <Select
                      isDisabled={itemData?.requisitionNo === '' ? false : true}
                      value={formData.RequisitionType}
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 5,
                        padding: 9,
                      })}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                          color: state.isFocused ? '#000 ' : '#000',
                          ':hover': {
                            backgroundColor: '#F5F5F5',
                            color: '#000 ',
                          },
                        }),
                      }}
                      className="w-100 p-0"
                      menuPlacement="auto"
                      menuShouldScrollIntoView={false}
                      options={itemType}
                      onChange={(selectedOption) => handleItemTypeChange(selectedOption)}
                    />
                  )}
                </div>
                <div className="col d-flex justify-content-between">
                  <label htmlFor="ContactNo" className="form-label">
                    Contact No
                  </label>
                  <input
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    className="form-Input w-100"
                    id="ContactNo"
                    disabled={itemData.eye === true ? true : false}
                    value={formData.ContactNo}
                    onChange={handleInputChange}
                    name="ContactNo"
                  />
                </div>
                <div className="col-4 d-flex justify-content-between">
                  <label htmlFor="PayOrderType" className="form-label">
                    Pay OrderType
                  </label>
                  <Select
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: 5,
                      padding: 9,
                    })}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      option: (provided, state) => ({
                        ...provided,
                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                        color: state.isFocused ? '#000 ' : '#000',
                        ':hover': {
                          backgroundColor: '#F5F5F5',
                          color: '#000 ',
                        },
                      }),
                    }}
                    className="w-100 p-0"
                    menuPlacement="auto"
                    menuShouldScrollIntoView={false}
                    isDisabled={itemData.eye === true ? true : false}
                    options={orderType}
                    value={formData.OrderType}
                    onChange={(selectedOption) => handlePyorderChange(selectedOption)}
                  />
                </div>
              </div>
              <div className="form-group row pb-3">
                <div className="col d-flex justify-content-between">
                  <label htmlFor="QuotationReq" className="form-label">
                    Quotation Req
                  </label>
                  <input
                    type="text"
                    className="form-Input w-100"
                    id="QuotationReq"
                    disabled
                    value={formData.QuotationReq}
                    onChange={handleInputChange}
                    name="QuotationReq"
                  />
                </div>
                {/* <div className="col d-flex justify-content-between">
                  <label htmlFor="BuyerName" className="form-label">
                    Buyer Name
                  </label>
                  <input
                    type="text"
                    className="form-Input w-100"
                    id="BuyerName"
                    disabled={itemData.eye === true ? true : false}
                    value={formData.BuyerName}
                    onChange={handleInputChange}
                    name="BuyerName"
                  />
                </div> */}

                <div className="col-4  d-flex justify-content-between">
                  <label htmlFor="deliveryDate" className="form-label  pt-2 start">Store *</label>
                  <Select
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: 5,
                      padding: 9
                    })}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      option: (provided, state) => ({
                        ...provided,
                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                        color: state.isFocused ? '#000 ' : '#000',
                        ':hover': {
                          backgroundColor: '#F5F5F5',
                          color: '#000 ',
                        },
                      }),
                    }}
                    value={selectedLocation}
                    onChange={(selectedOption) => handleDropdownChange('selectedLocation', selectedOption)}
                    options={Location?.map((loc) => ({ value: loc, label: loc?.description }))}
                    className="w-100 p-0"
                    menuPlacement="auto"
                    menuShouldScrollIntoView={false}
                  />
                </div>
                <div className="col d-flex justify-content-between">
                  <label htmlFor="Remarks" className="form-label">
                    Remarks
                  </label>
                  <textarea
                    disabled={itemData.eye === true}
                    className="form-Input w-100"
                    id="Remarks"
                    name="Remarks"
                    value={formData.Remarks}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              <div style={PO_DETAIL_QUOTE_GRID}>
                <div style={PO_DETAIL_FIELD_CELL} className="d-flex justify-content-between align-items-start">
                  <label className="form-label">Attachment</label>
                  <div
                    className="brderbox center d-flex align-items-center justify-content-center w-100"
                    style={{ cursor: itemData.eye ? 'default' : 'pointer', minHeight: '40px' }}
                    onClick={() => !itemData.eye && handleOpen()}
                    role="button"
                  >
                    Attachment
                  </div>
                </div>
              </div>
            </>
          </div>
        </div>
      </div>
      <div className="cost-center-section">
        <div className="d-flex mt-3 cursor-pointer slide-header" onClick={() => setSupplierTab(!SupplierTab)}>
          <div className="h6 pt-1">Supplier Details</div>
        </div>
        <div className={`slide-content ${SupplierTab ? 'open' : 'closed'}`}>
          <div className="border-box2 p-3">
            <>
              <div className="form-group row justify-content-between pb-3">
                <div className="col d-flex align-items-center">
                  <label htmlFor="inventoryAccountCode" className="form-label">
                    Vendor ID
                  </label>
                  {itemData?.requisitionNo === '' ? (
                    <Select
                      // isDisabled={itemData.eye === true ? true : false}
                      value={SupplierID}
                      onChange={(selectedOption) => handleSupplierChange(selectedOption)}
                      options={suppliers?.map((sup) => ({ value: sup, label: sup?.supplier_ID }))}
                      className="w-100 p-0"
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 5,
                        padding: 9,
                      })}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                          color: state.isFocused ? '#000 ' : '#000',
                          ':hover': {
                            backgroundColor: '#F5F5F5',
                            color: '#000 ',
                          },
                        }),
                      }}
                    />
                  ) : (
                    <Select
                      // isDisabled={itemData?.vendorName ? true : false}
                      value={SupplierID} options={suppliers?.map((sup) => ({ value: sup, label: sup?.supplier_ID }))}
                      className="w-100 p-0"
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 5,
                        padding: 9,
                      })}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                          color: state.isFocused ? '#000 ' : '#000',
                          ':hover': {
                            backgroundColor: '#F5F5F5',
                            color: '#000 ',
                          },
                        }),
                      }}
                      onChange={(selectedOption) => handleSupplierChange(selectedOption)}

                    />
                  )}
                </div>
                <div className="col d-flex align-items-center">
                  <label htmlFor="inventoryAccountCode" className="form-label">
                    Vendor Name
                  </label>
                  {itemData?.requisitionNo === '' ? (
                    <Select
                      className="flex-grow-1"
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 8,
                        padding: 9,
                      })}
                      // isDisabled={itemData.eye === true ? true : false}
                      value={Supplier}
                      options={suppliers?.map((sup) => ({ value: sup, label: sup?.supplierName }))}
                      onChange={(selectedOption) => handleSupplierChange(selectedOption)}
                    />
                  ) : (
                    <Select
                      className="flex-grow-1"
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 8,
                        padding: 9,
                      })}
                      value={Supplier}
                      // isDisabled={itemData?.vendorName ? true : false}
                      options={suppliers?.map((sup) => ({ value: sup, label: sup?.supplierName }))}
                      onChange={(selectedOption) => handleSupplierChange(selectedOption)}
                     
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                          color: state.isFocused ? '#000 ' : '#000',
                          ':hover': {
                            backgroundColor: '#F5F5F5',
                            color: '#000 ',
                          },
                        }),
                      }}
                    />
                  )}
                </div>
                <div className="col d-flex align-items-center">
                  <label htmlFor="inventoryAccountCode" className="form-label">
                    Payment terms
                  </label>
                  {itemData?.requisitionNo === '' ? (
                    <Select
                      className="flex-grow-1"
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 8,
                        padding: 9,
                      })}
                      value={Payment}
                      // isDisabled={itemData.eye === true ? true : false}
                      onChange={(selectedOption) => handlePayChange(selectedOption)}
                      options={payments?.map((sup) => ({ value: sup, label: sup?.description }))}
                    />
                  ) : (
                    <Select
                      className="flex-grow-1"
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 8,
                        padding: 9,
                      })}
                      value={Payment}
                      // isDisabled={itemData?.vendorName ? true : false}
                      onChange={(selectedOption) => handlePayChange(selectedOption)}
                      options={payments?.map((sup) => ({ value: sup, label: sup?.description }))}
                   
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                          color: state.isFocused ? '#000 ' : '#000',
                          ':hover': {
                            backgroundColor: '#F5F5F5',
                            color: '#000 ',
                          },
                        }),
                      }}
                    />
                  )}
                </div>
              </div>
              <div className="form-group row  pb-3">
                <div className="col-4 d-flex justify-content-between">
                  <label htmlFor="inventoryAccountCode" className="form-label">
                    Supplier Dept
                  </label>
                  {itemData?.requisitionNo === '' ? (
                    <Select
                      className="flex-grow-1"
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 8,
                        padding: 9,
                      })}
                      isDisabled={itemData.eye === true ? true : false}
                      value={formData.SupplierDep}
                      // options={department?.map((dep) => ({ value: dep, label: dep?.description }))}
                      onChange={(selectedOption) => handleDepChange(selectedOption)}
                    />
                  ) : (
                    <Select
                      className="flex-grow-1"
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 8,
                        padding: 9,
                      })}
                      isDisabled={itemData?.vendorName ? true : false}
                      value={formData.SupplierDep}
                      // options={department?.map((dep) => ({ value: dep, label: dep?.description }))}
                      onChange={(selectedOption) => handleDepChange(selectedOption)}
                    />
                  )}
                </div>
                <div className="col-4 d-flex justify-content-between">
                  <label htmlFor="Property" className="form-label">
                    Supplier Contact
                  </label>
                  {itemData?.requisitionNo === '' ? (
                    <input
                      disabled={itemData.eye === true ? true : false}
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      className="form-Input w-75"
                      id="SupplierContact"
                      value={SupplierContact}
                      onChange={handleInputChange}
                      name="SupplierContact"
                    />
                  ) : (
                    <input
                      disabled={itemData?.vendorName ? true : false}
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      className="form-Input w-75"
                      id="SupplierContact"
                      value={SupplierContact}
                      onChange={handleInputChange}
                      name="SupplierContact"
                    />
                  )}
                </div>
                <div className="col-4 pt-1 d-flex justify-content-between">
                  <div className="d-flex justify-content-between">
                    <div className="form-check">
                      <input
                        disabled={itemData.eye === true ? true : false}
                        style={{ width: '26px', height: '26px' }}
                        type="checkbox"
                        className="form-check-input"
                        checked={isVatExcluded}
                        onChange={handleVatChange}
                      />
                      <label className="form-check-label mx-2 mt-1">Vat Excluded</label>
                    </div>
                  </div>
                </div>
              </div>
            </>
          </div>
        </div>
      </div>
      <div className="cost-center-section">
        <div className="d-flex mt-3 cursor-pointer slide-header" onClick={() => setCostTab(!CostTab)}>
          <div className="h6 pt-1">Cost Center Details</div>
        </div>
        <div className={`slide-content ${CostTab ? 'open' : 'closed'}`}>
          <div className="border-box2 p-3">
            <>
              <div className="form-group row justify-content-between pb-3">
                <div className="col d-flex align-items-center">
                  <label htmlFor="inventoryAccountCode" className="form-label">
                    Property
                  </label>
                  <Select
                    id="costCenter1"
                    value={formData.costCenter1}
                    onChange={handleCost1}
                    options={cost1?.map((sup) => ({ value: sup, label: sup?.description }))}
                    className="flex-grow-1"
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: 8,
                      padding: 9,
                    })}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      option: (provided, state) => ({
                        ...provided,
                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                        color: state.isFocused ? '#000 ' : '#000',
                        ':hover': {
                          backgroundColor: '#F5F5F5',
                          color: '#000 ',
                        },
                      }),
                    }}
                    menuPlacement="auto"
                    menuShouldScrollIntoView={false}
                  />
                </div>
                <div className="col d-flex align-items-center">
                  <label htmlFor="inventoryAccountCode" className="form-label">
                    Unit
                  </label>
                  <Select
                    id="costCenter2"
                    value={formData.costCenter2}
                    onChange={handleCost2}
                    options={cost2?.map((sup) => ({ value: sup, label: sup?.text }))}
                    className="flex-grow-1"
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: 5,
                      padding: 9,
                    })}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      option: (provided, state) => ({
                        ...provided,
                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                        color: state.isFocused ? '#000 ' : '#000',
                        ':hover': {
                          backgroundColor: '#F5F5F5',
                          color: '#000 ',
                        },
                      }),
                    }}
                    menuPlacement="auto"
                    menuShouldScrollIntoView={false}
                  />
                </div>
                <div className="col d-flex align-items-center">
                  <label htmlFor="inventoryAccountCode" className="form-label">
                    Cost Center 3
                  </label>
                  <Select
                    id="costCenter3"
                    value={formData.costCenter3}
                    onChange={handleCost3}
                    options={cost3?.map((sup) => ({ value: sup, label: sup?.description }))}
                    className="flex-grow-1"
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: 5,
                      padding: 9,
                    })}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      option: (provided, state) => ({
                        ...provided,
                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                        color: state.isFocused ? '#000 ' : '#000',
                        ':hover': {
                          backgroundColor: '#F5F5F5',
                          color: '#000 ',
                        },
                      }),
                    }}
                    menuPlacement="auto"
                    menuShouldScrollIntoView={false}
                  />
                </div>
              </div>
              <div className="form-group row pb-3">
                <div className="col-4 d-flex align-items-center">
                  <label htmlFor="inventoryAccountCode" className="form-label">
                    Cost Center 4
                  </label>
                  <Select
                    id="costCenter4"
                    value={formData.costCenter4}
                    onChange={handleCost4}
                    options={cost4?.map((sup) => ({ value: sup, label: sup?.description }))}
                    className="flex-grow-1"
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: 5,
                      padding: 9,
                    })}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      option: (provided, state) => ({
                        ...provided,
                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                        color: state.isFocused ? '#000 ' : '#000',
                        ':hover': {
                          backgroundColor: '#F5F5F5',
                          color: '#000 ',
                        },
                      }),
                    }}
                    menuPlacement="auto"
                    menuShouldScrollIntoView={false}
                  />
                </div>
              </div>
            </>
          </div>
        </div>
      </div>
      <div className="slide-container p-2 mt-3">
        <div className="container-fluid">
          <div className="nav nav-pills overslid d-flex gap-4">
            {/* Nav tabs */}
            <div className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`} onClick={() => handleTabClick(0)}>
              Items
            </div>
            <div className={`dashitems sidebar-text center  ${activeTab === 1 ? 'sideActive' : ''}`} onClick={() => handleTabClick(1)}>
              Authorization
            </div>
            <div className={`dashitems sidebar-text center  ${activeTab === 2 ? 'sideActive' : ''}`} onClick={() => handleTabClick(2)}>
              Terms
            </div>
          </div>
        </div>
      </div>
      <div className="grid-1 brderbox2 p-4 mb-3">
        {gridVisibility[0] && (
          <UpdateItemGrid
            onRequisitionData={handleRequisitionData}
            itemData={itemData}
            selectedCheck={isVatExcluded}
            handleVatChange={handleVatChange}
            currencyPrecision={currencyPrecision?.exp1 || 3}
            setLoader={setLoader}
            loader={loader}
            setOverallDiscount={setOverallDiscount} overallDiscount={overallDiscount} setDiscountAmount={setDiscountAmount}
            discountAmount={discountAmount} setGrandTotal={setGrandTotal} grandTotal={grandTotal}
            vatAmount={vatAmount} setVatAmount={setVatAmount}
            isDiscountPercentage={isDiscountPercentage} setDiscountInputType={setDiscountInputType} discountInputType={discountInputType}
          />
        )}
        {gridVisibility[1] && <Authorization handleAuthorization={handleAuthorization} usersDetails={usersDetails} setUser={setUser} itemData={itemData} />}
        {gridVisibility[2] && (
          <div className="grid-3 border">
            <MessageGrid handleMessage={handleMessage} />
          </div>
        )}
      </div>
      <UpdateAttachment
        open={attachmentModal}
        rows={attachments}
        documentNo={poNumber}
        readOnly={itemData?.eye}
        onFileSelect={handleFileSelect}
        onRemarkChange={handleRemarkChange}
        onDelete={handleDelete}
        onClose={closeModal}
      />
    </div>
  );
};

export default UpdatePurchaseOrder;
